import React from "react";
import Explainer from "../ExplainerModal";

const PolicyPartnerExplainer = () => {
  return (
    <Explainer
      title="🤝 Policy Partners Explainer"
      content={
        <>
          <p>
            The <strong>Policy Partners</strong> section allows users to manage and track organizations/individuals involved in policy development. Partners play a crucial role in shaping and implementing policies within the agri-food sector.
          </p>

          <h3 style={{ fontSize: "18px", fontWeight: "bold", marginTop: "15px", color: "#333" }}>
            📌 Key Features
          </h3>
          <p>🏛️ <strong>Partner Details:</strong> Displays each partner's <strong>full name</strong> and <strong>abbreviation</strong> for easy identification.</p>
          <p>📋 <strong>Partner Management:</strong> Policy partners are created as needed while uploading a policy.</p>

          <h3 style={{ fontSize: "18px", fontWeight: "bold", marginTop: "15px", color: "#333" }}>
            ⚡ When to Create a New Partner?
          </h3>
          <p>
            If a policy requires collaboration with a partner that is not already listed in the system, users have the option to <strong>add a new partner</strong> directly within the platform while creating a policy
            under policy directory section.
          </p>
        </>
      }
    />
  );
};

export default PolicyPartnerExplainer;
